import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDocumentTitle } from 'usehooks-ts';

const TermsOfService: React.FC = () => {
    useDocumentTitle('Kullanım Koşulları | CO-HR');
    const history = useHistory();

    return (
        <div className="min-h-screen bg-white font-sans">
            <header className="sticky top-0 bg-white/90 backdrop-blur-xl border-b border-gray-100 z-50">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
                    <button onClick={() => history.push('/')} className="text-xl font-extrabold bg-gradient-to-r from-indigo-600 to-sky-500 bg-clip-text text-transparent focus:outline-none">
                        CO-HR
                    </button>
                    <button onClick={() => history.goBack()} className="text-sm text-gray-500 hover:text-gray-900 transition focus:outline-none">
                        &larr; Geri Dön
                    </button>
                </div>
            </header>

            <main className="max-w-4xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
                <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">Kullanım Koşulları</h1>
                <p className="text-gray-400 text-sm mb-10">Son güncelleme: 1 Nisan 2026</p>

                <div className="prose prose-gray max-w-none space-y-8 text-gray-700 leading-relaxed">
                    <section>
                        <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Genel Hükümler</h2>
                        <p>
                            Bu Kullanım Koşulları, CO-HR Performans Yönetim Sistemi ("Platform") üzerinden sunulan hizmetlerin
                            kullanımına ilişkin şart ve koşulları düzenler. Platforma erişerek veya kullanarak bu koşulları kabul
                            etmiş sayılırsınız.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Hizmet Tanımı</h2>
                        <p>CO-HR, kurumsal performans yönetimi için aşağıdaki hizmetleri sunan bulut tabanlı bir platformdur:</p>
                        <ul className="list-disc pl-6 space-y-1 mt-2">
                            <li>OKR ve hedef yönetimi</li>
                            <li>Performans kartı oluşturma ve değerlendirme</li>
                            <li>360° geri bildirim süreçleri</li>
                            <li>Yetkinlik değerlendirmeleri</li>
                            <li>Raporlama ve analitik araçları</li>
                            <li>Excel dışa aktarım</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Kullanıcı Yükümlülükleri</h2>
                        <p>Platform kullanıcıları aşağıdaki yükümlülüklere uymakla sorumludur:</p>
                        <ul className="list-disc pl-6 space-y-1 mt-2">
                            <li>Hesap bilgilerini gizli tutmak ve üçüncü kişilerle paylaşmamak</li>
                            <li>Platformu yalnızca yasal ve yetkili amaçlarla kullanmak</li>
                            <li>Diğer kullanıcıların verilerine yetkisiz erişim sağlamamak</li>
                            <li>Platformun güvenliğini tehlikeye atacak eylemlerden kaçınmak</li>
                            <li>Doğru ve güncel bilgiler sağlamak</li>
                            <li>Fikri mülkiyet haklarına saygı göstermek</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Hesap Güvenliği</h2>
                        <p>
                            Kullanıcılar, hesap bilgilerinin güvenliğinden sorumludur. Şifrenizi güçlü tutmanız ve düzenli olarak
                            değiştirmeniz önerilir. Hesabınızda yetkisiz bir erişim tespit etmeniz durumunda derhal bizimle
                            iletişime geçmeniz gerekmektedir.
                        </p>
                        <p className="mt-2">
                            CO-HR, şüpheli aktivite tespit etmesi halinde hesabınızı geçici olarak askıya alma hakkını saklı tutar.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Fikri Mülkiyet Hakları</h2>
                        <p>
                            Platform üzerindeki tüm içerik, tasarım, yazılım, logo, marka ve diğer fikri mülkiyet hakları CO-HR'a
                            veya lisans verenlerine aittir. Bu materyallerin izinsiz kullanımı, kopyalanması, dağıtılması veya
                            değiştirilmesi yasaktır.
                        </p>
                        <p className="mt-2">
                            Kullanıcılar tarafından platforma yüklenen veriler üzerindeki haklar, ilgili kullanıcıya veya
                            kurumuna aittir.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Hizmet Düzeyi ve Erişilebilirlik</h2>
                        <p>
                            CO-HR, platformun kesintisiz ve hatasız çalışması için azami özeni gösterir. Ancak planlı bakım
                            çalışmaları, teknik arızalar veya mücbir sebepler nedeniyle geçici kesintiler yaşanabilir.
                            Planlı bakım çalışmaları önceden bildirilir.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Sorumluluk Sınırlaması</h2>
                        <p>
                            CO-HR, platformun kullanımından doğabilecek doğrudan veya dolaylı zararlardan, veri kayıplarından
                            veya iş kesintilerinden sorumlu tutulamaz. Platform "olduğu gibi" sunulmakta olup, açık veya zımni
                            hiçbir garanti verilmemektedir.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Fesih</h2>
                        <p>
                            Kullanım koşullarının ihlali halinde CO-HR, kullanıcının hesabını önceden bildirimde bulunmaksızın
                            askıya alma veya sonlandırma hakkını saklı tutar. Kurumsal abonelikler, sözleşme koşullarına
                            tabidir.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gray-900 mb-3">9. Değişiklikler</h2>
                        <p>
                            CO-HR, bu kullanım koşullarını önceden bildirimde bulunarak değiştirme hakkını saklı tutar.
                            Değişiklikler platformda yayınlandığı tarihte yürürlüğe girer. Değişikliklerden sonra platformu
                            kullanmaya devam etmeniz, güncellenmiş koşulları kabul ettiğiniz anlamına gelir.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gray-900 mb-3">10. Uygulanacak Hukuk ve Yetki</h2>
                        <p>
                            Bu kullanım koşulları Türkiye Cumhuriyeti kanunlarına tabidir. Uyuşmazlıklarda İstanbul
                            Mahkemeleri ve İcra Daireleri yetkilidir.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gray-900 mb-3">11. İletişim</h2>
                        <p>
                            Kullanım koşulları hakkında sorularınız için bizimle iletişime geçebilirsiniz:
                        </p>
                        <p className="mt-2">
                            <strong>E-posta:</strong> info@co-hr.com.tr<br />
                            <strong>Web:</strong>{' '}
                            <a href="https://co-hr.com.tr" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:underline">
                                co-hr.com.tr
                            </a>
                        </p>
                    </section>
                </div>
            </main>

            <footer className="border-t border-gray-100 bg-gray-50 py-6">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center text-gray-400 text-sm">
                    Bu bir{' '}
                    <a href="https://co-hr.com.tr/" target="_blank" rel="noopener noreferrer" className="font-semibold text-gray-600 hover:text-indigo-500 transition">
                        CO-HR
                    </a>
                    {' '}ürünüdür.
                </div>
            </footer>
        </div>
    );
};

export default TermsOfService;
